module.exports = __webpack_public_path__ + "img/Discussion.67948d8c.png";